import Error404 from './images/Error404.png';

export const image404 = Error404;
